import { AppType } from '@blocs.common';
import { FiltersNameEnum, GetAdditionalInitialFiltersArgs } from '../types';
import { useInitialRolePreferences } from './useInitialRolePreferences';

export const useAdditionalInitialFilters = () => {
  const getInitialRolePreferences = useInitialRolePreferences();

  return ({
    isSubmissionContext,
    accountOrgFeatures,
    appliedFilters,
  }: GetAdditionalInitialFiltersArgs): { [key: string]: any } => {
    const initialRolePreferences = getInitialRolePreferences({
      isSubmissionContext,
      accountOrgFeatures,
      appliedFilters,
    });

    return {
      // Additional Initial form values of Casting
      [AppType.Casting]: {
        // Role Preferences
        [FiltersNameEnum.rolePreferences]: initialRolePreferences,
      },
      // Additional Initial form values of Reps
      [AppType.Reps]: {},
    };
  };
};
